const projects = [
  {
    id: 1,
    img: [require("../assets/images/project-images/Airbnb1.png").default, require("../assets/images/project-images/Airbnb2.png").default, require("../assets/images/project-images/Airbnb3.png").default],
    type: "rails",
    name: "Airrbnb",
    desc: "Airrbnb is a house renting and stays booking system and is a clone of Airbnb",
    stack: "Ruby / Rails",
    url: "https://github.com/deepakMaj/Airrbnb"
  },
  {
    id: 2,
    img: [require("../assets/images/project-images/Chatz1.png").default, require("../assets/images/project-images/Chatz2.png").default, require("../assets/images/project-images/Chatz3.png").default],
    type: "react",
    name: "Chatz",
    stack: "React JS / GraphQL",
    desc: "Chatz is a chat application to connect different users over same platform for communication and fun.",
    url: "https://github.com/deepakMaj/Chatz"
  },
  {
    id: 3,
    img: [require("../assets/images/project-images/Insta1.png").default, require("../assets/images/project-images/Insta2.png").default, require("../assets/images/project-images/Insta3.png").default],
    type: "rails",
    name: "Instagram",
    stack: "Ruby / Rails",
    desc: "Instagram is a social media web application and is a clone of original INSTAGRAM.",
    url: "https://github.com/deepakMaj/Instagram-Clone"
  },
  {
    id: 4,
    img: [require("../assets/images/project-images/Netflix1.png").default, require("../assets/images/project-images/Netflix2.png").default, require("../assets/images/project-images/Netflix3.png").default],
    type: "react",
    name: "Netflix",
    stack: "React JS / Firebase",
    desc: "Netflix is a binge watching and content streaming web application and is a clone of original NETFLIX.",
    url: "https://github.com/deepakMaj/Netflix-Clone"
  },
  {
    id: 5,
    img: [require("../assets/images/project-images/Spotify1.png").default, require("../assets/images/project-images/Spotify2.png").default, require("../assets/images/project-images/Spotify3.png").default],
    type: "angular",
    name: "Spotify",
    stack: "Angular / Ruby-Rails",
    desc: "Spotify is a music streaming web player application and is a clone of original SPOTIFY.",
    url: "https://github.com/deepakMaj/Spotify"
  },
  {
    id: 6,
    img: [require("../assets/images/project-images/Techshop1.png").default, require("../assets/images/project-images/Techshop2.png").default, require("../assets/images/project-images/Techshop3.png").default],
    type: "java",
    name: "TechShop",
    stack: "Java / Spring",
    desc: "TechShop is an e-commerce mobile devices shopping web application for simulating the shopping experience.",
    url: "https://github.com/deepakMaj/TechShop"
  },
  {
    id: 7,
    img: [require("../assets/images/project-images/Wanderlust1.png").default, require("../assets/images/project-images/Wanderlust2.png").default, require("../assets/images/project-images/Wanderlust3.png").default],
    type: "rails",
    name: "Wanderlust",
    stack: "Ruby / Rails",
    desc: "Wanderlust is a destinations, attractions and parks information application along with user reviews.",
    url: "https://github.com/deepakMaj/Wanderlust"
  },
  {
    id: 8,
    img: [require("../assets/images/project-images/YT1.png").default, require("../assets/images/project-images/YT2.png").default, require("../assets/images/project-images/YT3.png").default],
    type: "angular",
    name: "Youtube",
    stack: "Angular / Node.js",
    desc: "Youtube is a content streaming web application and is a clone of original YOUTUBE.",
    url: "https://github.com/deepakMaj/Youtube-Clone"
  }
];

export default projects;